import deepOrange from "@material-ui/core/colors/deepOrange";
import deepPurple from "@material-ui/core/colors/deepPurple";
import red from "@material-ui/core/colors/red";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import StarIcon from "@material-ui/icons/Star";
import PropTypes from "prop-types";
import React from "react";
import "./dark-voice.css";

const styles = theme => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: "inline"
  },
  avatar: {
    margin: 10
  },
  orangeAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: deepOrange[500]
  },
  purpleAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: deepPurple[500]
  },
  red: {
    // margin: 10,
    color: red[800]
    // backgroundColor: red[500]
  }
});

function DarkVoiceComponent(props) {
  const { classes } = props;
  return (
    <div className="timeline">
      <p className="headline">Major Projects</p>
      <List>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="‘The Inefficiencies of The Quota System’"
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="‘Causality Between Tax Revenue and Government Spending’"
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="‘Analysing the Effects of Domestic Macroeconomic Variables On KSE-100 Indices’"
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="‘Determinants of Economic Growth in United States of America’"
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="Developed a basic Not Free Cell game in python, and did the statistical analysis and visual presentation of statistical and stochastic properties of card games."
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="Developed a portfolio recommendation system in Python to hedge investments."
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="Developed a database system in Oracle SQL for a hypothetical restaurant."
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="Developed searching, traversing, genetic and evolutionary simulation algorithms in Python"
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="Developed optimization algorithms and stream processing using spark and database storage and
maintenance in MongoDB"
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="Developed a Dashboard using R, D3, CSS and HTML for Economic outlook and comparison of countries and
different kinds of country blocs worldwide."
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="Data Parsing, Cleansing and Integrating Raw Data and Pre-processing Text Data in Python."
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StarIcon className={classes.red} />
          </ListItemIcon>
          <ListItemText
            className="dark-voice"
            disableTypography
            inset
            primary="Developed various Machine Learning algorithms for Data Analysis in R programming language, without using
any inbuilt libraries."
          />
        </ListItem>
      </List>
    </div>
  );
}

DarkVoiceComponent.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DarkVoiceComponent);
